import { render, staticRenderFns } from "./GetQRCode.vue?vue&type=template&id=6f00720c&"
import script from "./GetQRCode.vue?vue&type=script&lang=js&"
export * from "./GetQRCode.vue?vue&type=script&lang=js&"
import style0 from "./GetQRCode.vue?vue&type=style&index=0&id=6f00720c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports